<template>
  <div>
    <h3 class="my-15">Clés de réussite</h3>

    <div class="text-xs pb-10 px-10 text-justify flex flex-col space-y-3">
      <p>
        La compensation d'un handicap est la réponse individuelle apportée à la
        personne en situation de handicap pour faire face aux "conséquences de
        son handicap quels que soient l'origine et la nature de sa déficience,
        son âge ou son mode de vie".
      </p>
      <p>
        Pour valider cette compensation, il est important de définir les
        principaux éléments (clefs de réussites) qui favoriseraient la prise en
        compte de votre (vos) situation(s) de handicap.
      </p>
      <p>
        Et donc réduiraient la (les) conséquence(s) de votre (vos) handicap(s)
        au travail ou en formation.
      </p>
      <p>
        Ex : J'ai des problèmes de dos qui m'empêchent d'avoir une posture
        assise et debout en continue. Une de vos clefs de réussite serait un
        aménagement de votre bureau de travail. Et donc de vous proposer un
        bureau réglable en hauteur (bureau assis-debout).
      </p>
      <p class="flex space-x-2 items-center">
        <icon name="alert-triangle" />
        <span>
          Il est nécessaire de mettre en avant sur votre CV uniquement les
          éléments qui sont essentiels. Pour ce faire, si tout vous convient
          dans les catégories proposées ci-dessous cocher la case "TOUT" et rien
          n'apparaitra sur le CV.
        </span>
      </p>
    </div>

    <!-- TODO : #1408 En attente de reprise pour le ticket
            <div class="px-10 pb-10 flex items-center space-x-2">
            <radio-button
                :name="'nosuccesscle'"
                :value="
                    ((((form || {}).data || {}).success || {}).value || {})
                        .all || false
                "
                @input="
                    (newValue) => {
                        displaySuccess('all', null, newValue);
                    }
                "
                @loseFocus="saveDatas()"
            />
            <p class="text-base font-normal">
                Pas d'élément spécifique à préciser
            </p>
        </div> -->

    <div
      v-if="isErrorMaxLengthDisplayed"
      class="text-pink-600 text-base text-center mb-8 mx-20"
    >
      ATTENTION : Il y a trop de clés de réussite. Cela risque d'altérer la
      présentation de votre CV.
    </div>
    <div v-if="!form?.data?.success?.value?.all">
      <div
        v-for="(libelleSucces, ks) in constants.cvdatas.listSuccess"
        :key="'libelleSucces' + ks"
        class="p-0 odd:bg-gray-200 odd:bg-opacity-50"
      >
        <accordion-item
          @clickOnItem="displayTypeSuccess(ks)"
          :is-accordion-displayed="typeSuccessToDisplay === ks"
        >
          <template #description>
            <div class="col-span-2 justify-self-center handle">
              <icon
                name="chevron-right"
                class="text-pink-600 h-3 transform transition-all duration-200"
                :class="{
                  'rotate-90': typeSuccessToDisplay === ks,
                }"
              />
            </div>
            <div class="col-span-10 text-base font-normal">
              {{ libelleSucces }}
            </div>
          </template>

          <template #content>
            <div class="grid grid-cols-3 gap-3 mb-3">
              <div
                v-for="(typePlace, ktp) in constants.cvdatas.success[ks]"
                :key="'typePlace' + ktp"
                class="col-span-full md:col-span-1"
              >
                <multiple-select
                  v-if="ks != 'office'"
                  :datas="
                    typePlace.reduce(
                      (acc, tp) => [
                        ...acc,
                        {
                          value:
                            tp[0].toUpperCase() + tp.slice(1).toLowerCase(),
                        },
                      ],
                      []
                    )
                  "
                  :name="ktp"
                  :libelle="ktp"
                  :value="(form.data.success.value[ks] || {})[ktp] || []"
                  :error="true"
                  @input="
                    (newValue) => {
                      displaySuccess(ks, ktp, newValue);
                    }
                  "
                  @loseFocus="saveDatas()"
                  :has-item-all="true"
                />
                <input-select
                  v-if="ks === 'office'"
                  :datas="
                    typePlace.reduce(
                      (acc, tp) => [
                        ...acc,
                        {
                          value:
                            tp[0].toUpperCase() + tp.slice(1).toLowerCase(),
                        },
                      ],
                      []
                    )
                  "
                  :name="ktp"
                  :libelle="ktp"
                  :value="(form.data.success.value[ks] || {})[ktp] || ''"
                  :error="true"
                  @input="
                    (newValue) => {
                      displaySuccess(ks, ktp, newValue);
                    }
                  "
                  @loseFocus="saveDatas()"
                />
              </div>
            </div>
          </template>
        </accordion-item>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Constants from './../../../constants';

import Icon from './../../../components/Icon.vue';
import AccordionItem from '../../../components/AccordionTable/AccordionItem.vue';
import InputSelect from './../../../components/Inputs/InputSelect.vue';
import MultipleSelect from './../../../components/Inputs/MultipleSelect.vue';

export default {
  components: {
    Icon,
    AccordionItem,
    MultipleSelect,
    InputSelect,
  },

  data() {
    return {
      typeSuccessToDisplay: '',
      constants: Constants,
      isErrorMaxLengthDisplayed: false,
    };
  },

  mounted() {
    this.displayLengthErrorMessage();
  },

  methods: {
    ...mapActions({
      saveDatas: 'curriculumVitae/saveDatas',
    }),

    displayTypeSuccess(typeSuccess) {
      if (this.typeSuccessToDisplay === typeSuccess) {
        this.typeSuccessToDisplay = '';
        return;
      }

      this.typeSuccessToDisplay = typeSuccess;
    },

    displaySuccess(typeSuccess, indexType, value) {
      if (typeSuccess === 'all') {
        this.form.data.success.value[typeSuccess] = value;
        this.saveDatas();
        return;
      }
      if (this.form.data.success.value[typeSuccess][indexType] === undefined) {
        this.form.data.success.value[typeSuccess] = {
          ...this.form.data.success.value[typeSuccess],
          [indexType]: typeSuccess === 'office' ? '' : [],
        };
      }

      this.form.data.success.value[typeSuccess][indexType] = value;
      this.saveDatas();

      //Verify content max length, but not block the save if too many values
      this.displayLengthErrorMessage();
    },

    displayLengthErrorMessage() {
      this.backdoor; //for reactivity
      if (this.hasLimit) {
        let nbCaractersPerLine = 26;

        let nbWorkplaceCaracters = Object.values(
          this.form.data.success.value.workplace
        )
          .filter(
            (w, iw) =>
              w &&
              !this.listSuccessWithAllValuesSelected.workplace[
                Object.keys(this.form.data.success.value.workplace)[iw]
              ] &&
              w.length > 0
          )
          .flat()
          .reduce((acc, w) => acc + w.length, 0);

        let nbConditionsCaracters = Object.values(
          this.form.data.success.value.conditions
        )
          .filter(
            (c, ic) =>
              c &&
              !this.listSuccessWithAllValuesSelected.conditions[
                Object.keys(this.form.data.success.value.conditions)[ic]
              ] &&
              c.length > 0
          )
          .flat()
          .reduce((acc, c) => acc + c.length, 0);

        let nbTeamworkCaracters = Object.values(
          this.form.data.success.value.teamwork
        )
          .filter(
            (t, it) =>
              t &&
              !this.listSuccessWithAllValuesSelected.teamwork[
                Object.keys(this.form.data.success.value.teamwork)[it]
              ] &&
              t.length > 0
          )
          .flat()
          .reduce((acc, t) => acc + t.length, 0);

        let nbOfficeCaracters = Object.keys(this.form.data.success.value.office)
          .filter((k) => this.form.data.success.value.office[k] === 'Oui')
          .reduce((acc, o) => acc + o.length, 0);

        nbWorkplaceCaracters = Math.ceil(
          nbWorkplaceCaracters / nbCaractersPerLine
        );
        nbConditionsCaracters = Math.ceil(
          nbConditionsCaracters / nbCaractersPerLine
        );
        nbTeamworkCaracters = Math.ceil(
          nbTeamworkCaracters / nbCaractersPerLine
        );
        nbOfficeCaracters = Math.ceil(nbOfficeCaracters / nbCaractersPerLine);

        let totalLines =
          nbWorkplaceCaracters +
          nbConditionsCaracters +
          nbTeamworkCaracters +
          nbOfficeCaracters;

        if (totalLines > 15) {
          this.isErrorMaxLengthDisplayed = true;
          return true;
        }

        this.isErrorMaxLengthDisplayed = false;
        return false;
      }
    },
  },

  computed: {
    ...mapGetters({
      form: 'curriculumVitae/form',
      newer: 'curriculumVitae/newForm',
      backdoor: 'app/backdoor',
    }),

    hasLimit() {
      return [Constants.CV_TYPES.DASHBOARD].includes(this.form.type);
    },

    listSuccessWithAllValuesSelected() {
      let result = {};

      Object.keys(Constants.cvdatas.success).forEach((typeSuccess) => {
        result[typeSuccess] = {};
        Object.keys(Constants.cvdatas.success[typeSuccess]).forEach((place) => {
          result[typeSuccess][place] =
            this.form?.data?.success?.value[typeSuccess][place]?.length ===
            Constants.cvdatas.success[typeSuccess][place].length;
        });
      });

      return result;
    },
  },

  watch: {
    form: {
      handler() {
        this.saveDatas();
      },
      deep: true,
    },
  },
};
</script>
